export const ActionTypes = {
  LOADING: "LOADING_ACTIONS",
  ERROR: "ERROR_ACTIONS",
  SUCCESS: "SUCCESS_ACTIONS",
};
